var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"iframe",attrs:{"src":_vm.url +'/homepage-widget.html'}})}
var staticRenderFns = []

export { render, staticRenderFns }